module.exports = __webpack_public_path__ + "media/images/img_mentor02-61fcf3bedc5fbd8fa4827298258e0344.jpg";